<p class="p-3">
  Redirecting to the forum
</p>
